const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "StatusName",
		label: "状态",
		columnwidth: 80,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 60,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "LEVEL1_5",
		label: "LEVEL1.5",
		columnwidth: 140,
	},
	{
		prop: "CusName",
		label: "经销商名称",
		columnwidth: 170,
	},
	{
		prop: "YearQuota",
		label: "总指标",
		columnwidth: 120,
	},
	{
		prop: "OrgName",
		label: "原经销商名称",
		columnwidth: 200,
	},
	{
		prop: "JanQuota",
		label: "一月指标",
		columnwidth: 130,
	},
	{
		prop: "FebQuota",
		label: "二月指标",
		columnwidth: 130,
	},
	{
		prop: "MarQuota",
		label: "三月指标",
		columnwidth: 130,
	},
	{
		prop: "AprQuota",
		label: "四月指标",
		columnwidth: 130,
	},
	{
		prop: "MayQuota",
		label: "五月指标",
		columnwidth: 130,
	},
	{
		prop: "JunQuota",
		label: "六月指标",
		columnwidth: 130,
	},
	{
		prop: "JulQuota",
		label: "七月指标",
		columnwidth: 130,
	},
	{
		prop: "AugQuota",
		label: "八月指标",
		columnwidth: 130,
	},
	{
		prop: "SepQuota",
		label: "九月指标",
		columnwidth: 130,
	},
	{
		prop: "OctQuota",
		label: "十月指标",
		columnwidth: 130,
	},
	{
		prop: "NovQuota",
		label: "十一月指标",
		columnwidth: 130,
	},
	{
		prop: "DecQuota",
		label: "十二月指标",
		columnwidth: 130,
	},
	{
		prop: "MarkupRate",
		label: "加价率",
		columnwidth: 120,
	},
	{
		prop: "ReviseTime",
		label: "修订日期",
		columnwidth: 120,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 120,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 120,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 120,
	}
];
export default headerData;